$(document).ready(function () {
	
	// Validate phone
	var telInput 		= 	$("#phone");
	var validPhone = $("#valid_phone");
	var phoneValid = $('#phone_valid');

	// initialise plugin
	telInput.intlTelInput({
		utilsScript: "/plugins/telinput/js/utils.js",
	});

	// on blur: validate
	telInput.blur(function () {
		if ($.trim(telInput.val())) {
			checkPhoneFieldEnter = 1;
			if (telInput.intlTelInput("isValidNumber")) {
				validPhone.val(1);
				phoneValid.val(true);
			} else {
				validPhone.val('');
				phoneValid.val(false);
			}
		}
	});
});